<template>
  <div>
    <f7-accordion-item class="accordionForm" @accordion:open="openedAccordion=true"
      @accordion:opened="openedFinishedAccordion=true"
      @accordion:close="openedAccordion=openedFinishedAccordion=false" :expanded="open">
      <f7-accordion-toggle class="accordionToggle w-fit-content">
        <div class="form-group row justify-content-start">
          <div class="col-sm-auto titleAccordion"
            :class="[(isTitleUpperCase ? 'text-uppercase' : ''), (isTitleBold ? 'font-weight-bold' : '')]">
            {{ title }}
            <span v-if="star" class="color-red"> *</span>
            <i class="ml-2 fa-light fa-chevron-down color-var-actionButtonColorBlue"
              v-if="openedAccordion">
            </i>
            <i class="ml-2 fa-light fa-chevron-right color-var-actionButtonColorBlue"
              v-if="!openedAccordion">
            </i>
          </div>
        </div>
      </f7-accordion-toggle>
      <f7-accordion-content :class="{accordionContentExpended: openedFinishedAccordion}">
        <slot></slot>
      </f7-accordion-content>
    </f7-accordion-item>
  </div>
</template>

<script>
export default {
  name: 'FormAccordion',
  props: {
    title: {
      type: String
    },
    open: {
      type: Boolean,
      default: true
    },
    star: {
      type: Boolean,
      default: false
    },
    hasDatePicker: {
      type: Boolean,
      default: false
    },
    chevron_open: {
      type: String,
      default: 'chevron_down'
    },
    chevron_close: {
      type: String,
      default: 'chevron_right'
    },
    isTitleUpperCase: {
      type: Boolean,
      default: true
    },

    isTitleBold: {
      type: Boolean,
      default: true
    }

  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      chevronColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id),
      openedAccordion: this.open,
      openedFinishedAccordion: this.open
    }
  },
  computed: {
    renderOpenClass () {
      return this.open ? 'accordion-item-expanded' : ''
    }
  },
  watch: {
    open () {
      this.openedAccordion = this.open
    }
  }
}
</script>